import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=db116126&scoped=true&"
import script from "./Face.vue?vue&type=script&lang=js&"
export * from "./Face.vue?vue&type=script&lang=js&"
import style0 from "./Face.vue?vue&type=style&index=0&id=db116126&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db116126",
  null
  
)

export default component.exports